import {useCallback, useReducer} from "react";
import {
  offeringFormAccordionReducer,
  initialOfferingFormAccordionState,
} from "../reducers";

export function useOfferingFormAccordion({
  reducer = offeringFormAccordionReducer,
}: {
  reducer: typeof offeringFormAccordionReducer;
}) {
  const [state, dispatch] = useReducer(reducer, initialOfferingFormAccordionState);
  const toggleIndex = useCallback(
    (index: number) => dispatch({type: "toggle_index", payload: index}),
    []
  );
  const openIndex = useCallback(
    (index: number) => dispatch({type: "open_index", payload: index}),
    []
  );
  return {openIndexes: state.openIndexes, toggleIndex, openIndex};
}
